"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function StrategicPartners() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const marqueeOne = [{
    name: "GLOBAL TECH",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_global_tech.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_global_tech.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_global_tech.png-wvc-sizes"
  }, {
    name: "FINANCE CORP",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_finance_corp.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_finance_corp.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_finance_corp.png-wvc-sizes"
  }, {
    name: "HEALTH SYSTEMS",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_health_systems.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_health_systems.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_health_systems.png-wvc-sizes"
  }, {
    name: "RETAIL LOGISTICS",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_retail_logistics.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_retail_logistics.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_retail_logistics.png-wvc-sizes"
  }, {
    name: "ENERGY SOLUTIONS",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_energy_solutions.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_energy_solutions.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_energy_solutions.png-wvc-sizes"
  }, {
    name: "MEDIA GROUP",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_media_group.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_media_group.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_media_group.png-wvc-sizes"
  }, {
    name: "CONSTRUCTION INC",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_construction_inc.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_construction_inc.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_construction_inc.png-wvc-sizes"
  }, {
    name: "TECH VENTURES",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_tech_ventures.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_tech_ventures.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_tech_ventures.png-wvc-sizes"
  }];
  const marqueeTwo = [{
    name: "CLOUD DYNAMICS",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_cloud_dynamics.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_cloud_dynamics.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_cloud_dynamics.png-wvc-sizes"
  }, {
    name: "DATA ANALYTICS",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_data_analytics.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_data_analytics.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_data_analytics.png-wvc-sizes"
  }, {
    name: "CYBER SECURITY",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_cyber_security.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_cyber_security.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_cyber_security.png-wvc-sizes"
  }, {
    name: "AI RESEARCH",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_ai_research.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_ai_research.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_ai_research.png-wvc-sizes"
  }, {
    name: "BLOCKCHAIN LABS",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_blockchain_labs.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_blockchain_labs.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_blockchain_labs.png-wvc-sizes"
  }, {
    name: "FINTECH GROUP",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_fintech_group.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_fintech_group.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_fintech_group.png-wvc-sizes"
  }, {
    name: "BIO TECH",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_bio_tech.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_bio_tech.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_bio_tech.png-wvc-sizes"
  }, {
    name: "GREEN ENERGY",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_green_energy.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_green_energy.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/partner_green_energy.png-wvc-sizes"
  }];
  const featuredPartners = [{
    name: "Global Tech",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/featured_global_tech.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/featured_global_tech.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/featured_global_tech.png-wvc-sizes"
  }, {
    name: "Finance Corp",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/featured_finance_corp.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/featured_finance_corp.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/featured_finance_corp.png-wvc-sizes"
  }, {
    name: "Health Systems",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/featured_health_systems.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/featured_health_systems.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/featured_health_systems.png-wvc-sizes"
  }, {
    name: "Retail Logistics",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/featured_retail_logistics.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/featured_retail_logistics.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/featured_retail_logistics.png-wvc-sizes"
  }, {
    name: "Energy Solutions",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/featured_energy_solutions.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/featured_energy_solutions.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/featured_energy_solutions.png-wvc-sizes"
  }, {
    name: "Media Group",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/featured_media_group.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/featured_media_group.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/featured_media_group.png-wvc-sizes"
  }, {
    name: "Construction Inc",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/featured_construction_inc.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/featured_construction_inc.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/featured_construction_inc.png-wvc-sizes"
  }, {
    name: "Tech Ventures",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/featured_tech_ventures.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/featured_tech_ventures.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/featured_tech_ventures.png-wvc-sizes"
  }, {
    name: "Cloud Dynamics",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/featured_cloud_dynamics.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/featured_cloud_dynamics.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/featured_cloud_dynamics.png-wvc-sizes"
  }, {
    name: "Data Analytics",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/featured_data_analytics.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/featured_data_analytics.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/featured_data_analytics.png-wvc-sizes"
  }, {
    name: "Cyber Security",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/featured_cyber_security.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/featured_cyber_security.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/featured_cyber_security.png-wvc-sizes"
  }, {
    name: "AI Research",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/featured_ai_research.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/featured_ai_research.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701280/img/featured_ai_research.png-wvc-sizes"
  }];
  const marqueeOneDoubled = [...marqueeOne, ...marqueeOne];
  const marqueeTwoDoubled = [...marqueeTwo, ...marqueeTwo];
  return <section data-section-id="3769" id="strategic-partners" className="bg-background text-foreground relative py-24 md:py-32 overflow-hidden">
      <style>{`
        @keyframes flux-marquee-left {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        @keyframes flux-marquee-right {
          0% { transform: translateX(-50%); }
          100% { transform: translateX(0); }
        }
        .flux-marquee-track-left {
          animation: flux-marquee-left 60s linear infinite;
        }
        .flux-marquee-track-right {
          animation: flux-marquee-right 75s linear infinite;
        }
      `}</style>

      <div className="absolute top-6 left-6 w-4 h-4 border-l border-t border-border" aria-hidden="true" />
      <div className="absolute top-6 right-6 w-4 h-4 border-r border-t border-border" aria-hidden="true" />
      <div className="absolute bottom-6 left-6 w-4 h-4 border-l border-b border-border" aria-hidden="true" />
      <div className="absolute bottom-6 right-6 w-4 h-4 border-r border-b border-border" aria-hidden="true" />

      <div ref={ref} className={`max-w-7xl mx-auto px-6 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="font-mono text-xs tracking-widest mb-6 text-primary">
            [ § INDUSTRY PARTNERSHIPS ]
          </div>
          <h2 className="font-default text-4xl md:text-6xl font-bold leading-[1.05] tracking-tight mb-6">
            <span className="block text-foreground">POWERING THE</span>
            <span className="block text-primary">
              FUTURE OF TALENT
            </span>
          </h2>
          <p className="font-default text-base md:text-lg text-muted-foreground max-w-[60ch] mx-auto leading-relaxed">
            Nexus Talent Partners collaborates with industry-leading organizations to bridge the gap between exceptional talent and the companies defining the next generation of corporate excellence.
          </p>
        </div>
      </div>

      <div className="relative w-full overflow-hidden py-6 border-y border-border mb-2">
        <div className="flex flux-marquee-track-left w-max">
          {marqueeOneDoubled.map((item, i) => <div key={i} data-index={i} className="flex items-center gap-10 px-10 shrink-0">
              <img src={item.src} data-wvc-srcset={item.srcset} data-wvc-sizes={item.sizes} alt={item.name} loading="lazy" decoding="async" className="h-8 w-auto opacity-60" />
              <span className="font-mono text-xs text-primary" aria-hidden="true">
                •
              </span>
            </div>)}
        </div>
      </div>

      <div className="relative w-full overflow-hidden py-6 border-b border-border mb-16">
        <div className="flex flux-marquee-track-right w-max">
          {marqueeTwoDoubled.map((item, i) => <div key={i} data-index={i} className="flex items-center gap-10 px-10 shrink-0">
              <img src={item.src} data-wvc-srcset={item.srcset} data-wvc-sizes={item.sizes} alt={item.name} loading="lazy" decoding="async" className="h-8 w-auto opacity-60" />
              <span className="font-mono text-xs text-primary" aria-hidden="true">
                •
              </span>
            </div>)}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-px bg-border border border-border">
          {featuredPartners.map((partner, i) => <div key={i} data-index={i} className="group relative bg-background p-6 flex items-center justify-center transition-all duration-300 hover:-translate-y-1 hover:bg-muted" style={{
          minHeight: "120px"
        }}>
              <div className="absolute top-1.5 left-1.5 w-2 h-2 border-l border-t opacity-0 group-hover:opacity-100 transition-opacity duration-300 border-primary" aria-hidden="true" />
              <div className="absolute top-1.5 right-1.5 w-2 h-2 border-r border-t opacity-0 group-hover:opacity-100 transition-opacity duration-300 border-primary" aria-hidden="true" />
              <div className="absolute bottom-1.5 left-1.5 w-2 h-2 border-l border-b opacity-0 group-hover:opacity-100 transition-opacity duration-300 border-primary" aria-hidden="true" />
              <div className="absolute bottom-1.5 right-1.5 w-2 h-2 border-r border-b opacity-0 group-hover:opacity-100 transition-opacity duration-300 border-primary" aria-hidden="true" />

              <img src={partner.src} data-wvc-srcset={partner.srcset} data-wvc-sizes={partner.sizes} alt={partner.name} loading="lazy" decoding="async" className="h-[60px] w-auto opacity-50 group-hover:opacity-100 transition-opacity duration-300" />
            </div>)}
        </div>

        <div className="text-center mt-12">
          <div className="font-mono text-xs tracking-widest text-muted-foreground">
            [ ESTABLISHED 2010
            <span className="mx-3 text-primary">/</span>
            150+ CORPORATE PARTNERS ]
          </div>
        </div>
      </div>
    </section>;
}